module.exports = __webpack_public_path__ + "img/imn.8c10222d.svg";